import request from '@/utils/request'
const baseUrl = '/ims'

export function backMenuList() {
  return request({
    url: baseUrl + `/Uapi/menu/module`,
    method: "get",
  });
}

export function friendApply(memberCode) {
  return request({
    url: baseUrl + `/Uapi/member/friend/apply/${memberCode}`,
    method: "POST",
  });
}

export function identityQuery(params) {
  return request({
    url: baseUrl + `/Uapi/member/identity/query`,
    method: "get",
    params,
  });
}

// 邮箱重置密码
export function resetPassword(data) {
  return request({
    url: `/upms/user/inner/resetPwd/email`,
    method: "POST",
    data
  });
}

// 邮箱注册
export function registerByEmail(data) {
  return request({
    url: `/upms/user/inner/register/email`,
    method: "POST",
    data
  });
}

// 获取邮箱验证码（应答data里是一个uuid字符串）
export function sendEmailCode(data) {
  return request({
    url: `/upms/email/send/code`,
    method: "POST",
    data
  });
}

// 校验邮箱验证码（应答data里是一个uuid字符串）
export function checkEmailCode(data) {
  return request({
    url: `/upms/email/check/code`,
    method: "POST",
    data
  });
}

export function memberEditName(data) {
  return request({
    url: `/ims/Uapi/user/editName?name=${data.name}`,
    method: 'PUT',
    data
  })
}

export function memberEditMobile(data) {
  return request({
    url: `/ims/Uapi/user/editMobile?mobile=${data.mobile}&code=${data.code}&uuid=${data.uuid}`,
    method: 'PUT',
    data
  })
}

export function memberEditPassword(data) {
  return request({
    url: `/ims/Uapi/user/current/passwd`,
    method: 'PUT',
    data
  })
}